import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { i18nReady } from './i18n';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme'; // ✅ zorg dat je theme.js aanmaakt

if (window.__RETAILMAPS_UNSUPPORTED_BROWSER__) {
  throw new Error("Unsupported browser for Retailmaps");
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
};

Promise.resolve(i18nReady).then(
  renderApp,
  (error) => {
    console.warn("i18n initialization failed, rendering with fallback language:", error);
    renderApp();
  }
);

reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch((error) => console.warn("Service worker cleanup failed:", error));

    if (window.caches) {
      window.caches
        .keys()
        .then((cacheNames) => Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName))))
        .catch((error) => console.warn("Cache cleanup failed:", error));
    }
  });
}
